<template>
  <ManyToManyForm
    v-model="internalValue"
    :elements="needs"
    fieldToDisplay="description" />
</template>

<script>

import ManyToManyForm from "@/components/forms/ManyToManyForm.vue";
import { useInterventionReportOptionsStore } from "@/stores/interventionReportOptions";

export default {
  name: "ImprovementNeedsForm",
  components: {
    ManyToManyForm,
  },
  props: {
    modelValue: {
      type: Array,
      required: false,
      default: () => {return [];},
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      interventionReportOptionsStore: useInterventionReportOptionsStore(),
      internalValue: this.modelValue,
      interventionReportOptionsStore: useInterventionReportOptionsStore(),
    };
  },
  computed: {
    needs() {
      return this.interventionReportOptionsStore.getImprovementNeeds;
    },
  },
  watch: {
    internalValue(newVal) {
      this.$emit("update:modelValue", newVal);
    },
    modelValue(newVal) {
      this.internalValue = newVal;
    },
  },
};
</script>
